const SpanishMexicoTranslation = {
  translation: {
    common: {
      OR: 'or',
      upToDate: 'El contenido esta actualizado',
      visitSite: 'Go to the site',
      assessment: {
        excellent: 'Excellent',
        veryGood: 'Very good',
        good: 'Good',
        acceptable: 'Acceptable',
        bad: 'Bad',
      },
      back: 'Volver',
      cancel: 'Cancelar',
      clear: 'Borrar',
      apply: 'Aplicar',
      send: 'Enviar',
      noItemsFound: 'Sorry we can not find any items.',
      day: '{{n}} día',
      days: '{{n}} días',
      today: 'hoy',
      tomorrow: 'mañana',
    },
    footer: {
      links: {
        legalConditions: 'Condiciones legales',
        privacyPolicy: 'Política de privacidad',
        cookiesPolicy: 'Política de cookies',
      },
    },
    validation: {
      error: {
        invalidEmail: 'Formato de correo electrónico inválido',
        invalidBirthDate: 'La fecha introducida no es válida. Debes ser mayor de edad',
        invalidPhone: 'Este campo es obligatorio',
        required: 'Este campo es obligatorio',
        telephone: 'Este campo es obligatorio',
        policies: 'Debe de aceptar las condiciones para continuar.',
        passwordMismatch: 'Las contraseñas no coinciden',
        numbersNotAllowed: 'Números no permitidos',
        invalidPhoneValue: 'Introduce un teléfono válido',
        alreadyVerifiedPhone: 'Este teléfono ya está verificado',
        notification: 'Código de error: ',
      },
    },
    option: {
      gender: {
        choose: 'Elige uno',
        MALE: 'Hombre',
        FEMALE: 'Mujer',
        OTHER: 'Otro',
        NOT_ANSWERED: '-',
      },
      policies: {
        platformCommunications: 'Platform Communications',
        retailerCommunications: 'Retailer Communications',
        dataLinkWithSAZ: 'Link profile with ShopAdvizor',
        thirdPartyCommunications: 'Third Party Communications',
        telephoneSazCommunications: 'SAZ telephone communications',
        telephoneOthersCommunications: 'Walmart Aurrera telephone communications',
      },
      diet: {
        omnivorous: 'Ninguna, como de todo',
        flexitarian: 'Flexitariano',
        rawFood: 'Crudívoro',
        vegetarian: 'Vegetariano',
        vegan: 'Vegano',
        other: 'Otra',
      },
      interest: {
        sports: 'Deportes',
        reading: 'Lectura',
        cultural: 'Intereses culturales',
      },
      lifestyle: {
        gardening: 'Amante de la jardinería',
        closeFriends: 'Valoro el tiempo con un pequeño grupo de amigos',
        careerAndFamily: 'Encuentro satisfacción en mi carrera y en mi familia',
        qualityTime: 'Tiendo a favorecer la calidad sobre la economía',
        socialMedia: 'Disfruto de conectarse en línea. Soy fan de redes sociales',
        healthWithoutTime: 'Quiero un estilo de vida saludable, pero no tengo mucho tiempo',
        aesthetics: 'Preocupado por la salud y la apariencia',
        environment: 'Con conciencia ambiental',
        selfEducation: 'Buscando educarme',
        health: 'Consciente de la nutrición / salud',
      },
      educationLevel: {
        0: 'Level 0: Pre-primary education',
        1: 'Level 1: Primary education or first stage of basic education',
        2: 'Level 2: Lower secondary education or second stage of basic education',
        3: 'Level 3: Upper secondary education',
        4: 'Level 4: Post-secondary non-tertiary education',
        5: 'Level 5: Short-cycle tertiary education',
        6: "Level 6: Bachelor's or equivalent",
        7: "Level 7: Master's or equivalent",
        8: 'Level 8: Doctoral or equivalent',
      },
      yesOrNot: {
        YES: 'Yes',
        NO: 'No',
        NOT_ANSWERED: '-',
      },
      preference: {
        alcohol: 'Alcohol',
        bio: 'Bio',
        light: 'Light',
        noGluten: 'Without gluten',
      },
      numberOfHomeComponent: {
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        '5+': 'More than 5',
      },
    },
    aside: {
      myAccount: 'Mi perfil',
      promotions: 'Promociones disponibles',
      coupons: 'Mis cupones',
      evaluations: 'Recuperar sazcoins',
      howItWorks: '¿Cómo funciona?',
      shops: 'Tiendas adscritas',
      contact: 'Contacto',
      faq: 'Preguntas frecuentes',
      termsAndConditions: 'Términos y condiciones',
      privacy: 'Política de privacidad',
      cookies: 'Política de cookies',
      logout: 'Cerrar sesión',
    },
    forms: {
      signIn: {
        caption: 'Iniciar sesión',
        label: {
          username: 'Correo electrónico',
          password: 'Contraseña',
        },
        placeholder: {
          username: 'Correo electrónico',
          password: 'Contraseña',
        },
        cta: {
          signUp: 'Crea tu cuenta',
          resetPass: 'Olvidé mi contraseña',
          monavis: 'Connect through Monavislerendgratuit.com',
          submit: 'Iniciar sesión',
        },
        error: {
          invalid: 'Los datos introducidos son incorrectos.',
          passwordRequired: 'Debes introducir tu contraseña',
          emailRequired: 'Debes rellenar tu dirección de correo electrónico',
          emailFormat:
            'El correo electrónico que has introducido no coincide con el formato de una dirección de correo electrónico',
          network: 'Network error. Please try again in a few moments.',
          invalidCredentials: {
            title: 'Los datos introducidos son incorrectos.',
            description:
              'Vuelve a intentarlo o selecciona “Olvidé mi contraseña” en caso hayas olvidado tu contraseña y quieras cambiarla.',
          },
          inactive: {
            description:
              'Para poder iniciar sesión, tienes que activar tu cuenta haciendo clic en el link del email que has recibido cuando te registraste. Revisa en tu bandeja de SPAM.',
          },
        },
      },
      signUp: {
        caption: 'Crear cuenta',
        captionSso: 'Termina de registrarte',
        captionSsoText: 'Esta información proviene de Google',
        label: {
          platform: 'Acepto recibir comunicaciones por email',
          email: 'Correo electrónico',
          password: 'Contraseña',
          passwordRepeat: 'Repetir contraseña',
          firstName: 'Nombre',
          lastName: 'Apellido',
          gender: 'Género',
          birthDate: 'Fecha de nacimiento',
          phoneNumber: 'Número de teléfono móvil',
          state: 'Estado',
          city: 'Ciudad',
          zipCode: 'Código postal',
          line1: 'Calle y número',
          line2: 'Colonia',
          telephone: 'Teléfono',
          policies: 'Acepto las Condiciones Legales y la Política de Confidencialidad de Shopadvizor',
        },
        placeholder: {
          email: 'Correo electrónico',
          password: 'Contraseña',
          passwordRepeat: 'Repetir contraseña',
          firstName: 'Nombre',
          lastName: 'Apellido',
          birthDate: 'dd/mm/aaaa',
          phoneNumber: 'Número de teléfono móvil',
          telephone: 'Número de teléfono sin prefijo',
          state: 'Estado',
          city: 'Ciudad',
          zipCode: 'Código postal',
          line1: 'Calle y número',
          line2: 'Núm Interior, Referencias, Entrada...',
        },
        cta: {
          title: 'Acepto las <1>Condiciones Legales</1>, y la <3>Política de Confidencialidad</3> de Shopadvizor.',
          logIn: '¿Ya estas registrado? Haz click aquí.',
          submit: 'Aceptar y unirse',
          step1: 'Al hacer clic en «Aceptar y unirse», aceptas las',
          step2: 'Condiciones de uso',
          step3: 'Política de privacidad',
          step4: 'Política de cookies',
          step5: 'de Shopadvizor.',
        },
        error: {
          unique: 'Ya existe usuario con este email',
          profile: 'Ya existe usuario con este perfil',
          network: 'Error de red, vuelva a intentarlo mas tarde',
        },
      },
      profile: {
        textMail: 'Si quieres modificar tus datos personales, escríbenos a ',
        headers: {
          policies: 'Comunicaciones',
          preferences: 'Preferences',
          education: 'Education',
          couple: 'Couple',
          pet: 'Pet',
          style: 'Mi perfil alimentario',
          profile: 'Mi perfil personal',
          personal: 'Mis datos personales',
          address: 'Mi dirección',
          home: 'Composición de mi hogar',
          checks: 'Mis comunicaciones',
        },
        label: {
          name: 'Nombre',
          google: 'Introduzca su dirección para autocompletar los campos',
          childs: 'Hijos (*)',
          lastname: 'Apellido',
          email: 'Email',
          identifier: 'Número de identidad',
          gender: 'Género',
          diets: 'Dieta especial (*)',
          interest: 'Hobbies (*)',
          interestError: 'Hobbies (*) Este campo es obligatorio',
          lifestyle: 'Lifestyle (*)',
          lifestyleError: 'Lifestyle (*) Este campo es obligatorio',
          telephone: 'Número de teléfono',
          partnerGender: 'Género',
          partnerFirstName: 'Nombre',
          partnerBirthDate: 'Fecha de nacimiento',
          numberOfHomeComponents: 'Número de personas que componen el hogar',
          state: 'Provincia',
          city: 'Corregimiento',
          zipCode: 'Zip code',
          line1: 'Calle',
          line2: 'Distrito',
          addressText: 'Complemento de la dirección',
          hasPartner: '¿Tiene pareja?',
          hasPet: '¿Tiene mascota?',
          educationLevelCode: '',
          birthDate: 'Fecha de nacimiento',
          birthDateChild: 'Fecha de nacimiento del hijo',
          alcohol: '¿Quieres recibir productos que contengan alcohol? (*)',
          allergies: '¿Tienes tú o algún miembro de tu hogar alguna alergia alimentaria? (*)',
        },
        placeholder: {
          diets: 'Dieta especial',
          identifier: 'Número de identidad',
          phoneVerified: 'Número verificado',
          phoneNotVerified: 'Número no verificado',
          modifyOrVerify: 'Modificar o verificar mi teléfono',
          childs: 'Introduzca el número de hijos',
          interest: 'Hobbies',
          lifestyle: 'Lifestyle',
          gender: 'Elige uno',
          telephone: 'Número de teléfono',
          partnerGender: 'Your partner gender',
          partnerFirstName: 'Your partner firstname',
          partnerBirthDate: 'Your partner lastname',
          numberOfHomeComponents: 'Número de personas que componen el hogar',
          state: 'State',
          noResults: 'No hay resultado',
          city: 'City',
          zipCode: 'Zip code',
          line1: 'Lugar de residencia',
          line2: 'Enter your additional info',
          hasPartner: 'Do you have a partner?',
          hasPet: '¿Tiene mascota?',
          educationLevelCode: 'What are your educational level?',
          birthDate: 'Fecha de nacimiento',
          birthDateChild: 'Fecha de nacimiento del hijo',
        },
        cta: {
          logIn: 'Already registered?, Log in',
          submit: 'Create your account',
        },
        error: {
          network: 'Network error',
        },
        telephone: {
          title: 'Teléfono',
          change: 'Editar',
          confirm: 'Confimar',
          message: {
            noPhone: 'xx-xxxxxxxx',
          },
        },
        steps: {
          label: {
            numberOfHomeComponents: '¿Cuántas personas viven en tu hogar?',
            children: '¿Cuántos hijos tienes?',
            pets: '¿Tienes alguna mascota?',
          },
          placeholder: {
            numberOfHomeComponents: '¿Cuántas personas viven en tu hogar?',
            children: '¿Cuántos hijos tienes?',
            pets: '¿Tienes alguna mascota?',
          },
        },
        allergiesOptions: {
          milk: 'Leche y sus derivados (incluida la lactosa).',
          crustaceans: 'Crustáceos y productos a base de crustáceos.',
          eggs: 'Huevos y productos a base de huevo.',
          treeNuts:
            'Frutos de cáscara (Almendras, avellanas, nueces, anacardos, pacanas, nueces de Brasil, pistachos, nueces de macadamia o nueces de Australia) y productos derivados.',
          gluten:
            'Cereales que contengan gluten (trigo, centeno, cebada y avena) o sus variedades híbridas y productos derivados.',
          fish: 'Pescado y productos a base de pescado.',
          peanuts: 'Cacahuetes (maní) y productos a base de cacahuetes.',
          soybeans: 'Soja y productos a base de soja.',
          celery: 'Apio y productos derivados.',
          mustard: 'Mostaza y productos derivados.',
          sesameSeeds: 'Granos de sésamo y productos a base de granos de sésamo.',
          sulfurDioxideAndSulfites: 'Dióxido de azufre y sulfitos.',
          lupine: 'Altramuces y productos a base de altramuces.',
          molluscs: 'Moluscos y productos a base de moluscos.',
        },
      },
      photo: {
        description: {
          title: 'Change your avatar image',
          subtitle1: 'It must be jpg,png',
          subtitle2: 'it must be below 2.5M',
        },
        cta: {
          add: 'Add photo',
          edit: 'Edit photo',
          delete: 'Delete photo',
        },
        caption: {
          file: 'Change your avatar',
          submit: 'Save changes',
        },
        notification: {
          success: 'Your photo has changed',
          error: 'Error, connection failed',
        },
      },
      telephoneExtended: {
        title: '¡Vas a pedir tu primer producto!',
        smsErrorLimit: 'Has gastado todos tus intentos de confirmación posible. Vuelve a intentarlo en 1 hora.',
        subtitle:
          'Te pedimos estos datos la primera vez para poder entregarte los productos de envío a domicilio si los eliges, ¡nunca más tendrás que rellenarlos!',
        boxText:
          'Como es la primera vez que vas a pedir un producto, te llegará un SMS con un código para que puedas validar tu número de teléfono. ¡Solamente tendrás que hacerlo una vez!',
        identifier: '¿Cuál es tu número de identidad?',
        address: '¿Cuál es tu dirección de residencia?',
        telephone: 'Indícanos tu número de teléfono móvil',
        googleTitle: 'Introduce tu dirección para autocompletar los campos',
        telephoneExtra: 'Más adelante te pediremos verificar tu número de teléfono',
        sms: 'Introduce el código que te hemos mandado por SMS',
        phoneLabel: 'Teléfono (*)',
        phonePlaceholder: 'Teléfono móvil',
      },
      telephone: {
        error: 'Este campo es obligatorio',
        description: {
          title: 'Introduce tu número de teléfono',
          text: 'Ahora te mandaremos un SMS con un código para confirmar tu número.',
        },
        caption: {
          telephone: {
            label: 'Número de teléfono',
            placeholder: 'Número de teléfono sin código de país.',
          },
          submit: 'Siguiente',
          link: 'Ahora no, confirmaré mi teléfono más tarde',
        },
        notification: {
          success: 'Se ha actualizado su teléfono',
          error: 'Error, connection failed',
        },
        verify: {
          title: 'Introduce tu número de teléfono',
          subtitle: 'Te vamos a mandar un SMS con un código de verificación.',
          submitOne: 'Verificar',
          validatePhoneError: 'Este campo es obligatorio',
        },
      },
      telephoneToken: {
        description: {
          title: '¡Ya casi terminamos! Solo falta verificar tu teléfono',
          subtitle: 'Te enviamos un SMS con un código de verificación a este número:  ',
          code: {
            title: 'Introduce el código',
            subtitle: 'Atención: El código puede tardar unos minutos en llegar.',
          },
        },
        caption: {
          telephone: {
            label: 'Número de teléfono',
            placeholder: 'Número de teléfono sin código de país.',
          },
          submit: 'Finalizar',
          reSend: 'Enviar de nuevo el código',
          rePhone: 'No es mi teléfono',
        },
        notification: {
          success: 'Tu teléfono se ha verificado correctamente.',
          successSend: 'Le hemos reenviado el código de nuevo.',
          error: 'Código incorrecto',
        },
      },
      resetPassword: {
        caption: '¿Has olvidado tu contraseña?',
        subCaption:
          'Introduce tu dirección de correo electrónico y te enviaremos un enlace para restablecer la contraseña.',
        captionError: 'Not valid token.',
        label: {
          email: 'Correo electrónico',
        },
        placeholder: {
          email: 'Correo electrónico',
        },
        notification: {
          success: 'Si tu email tiene una cuenta asociada, recibirás un correo para restablecer tu contraseña',
          error: 'Error, fallo de conexión',
        },
        cta: {
          submit: 'Enviar',
          back: 'Volver al login',
        },
      },
      confirmPassword: {
        error: {
          required: 'Campo obligatorio',
          regexp:
            'Tu contraseña debe tener al menos 10 caracteres, una mayúscula, una minúscula, un número y un símbolo.',
          match: 'Las contraseñas introducidas no coinciden',
        },
        caption: 'Crea tu nueva contraseña',
        subCaption: 'Introduce una contraseña nueva. Te la pediremos siempre que inicies sesión.',
        captionError: 'El token es inválido.',
        label: {
          password: 'Nueva contraseña',
          confirm: 'Confirma tu contraseña',
        },
        placeholder: {
          password: 'Nueva contraseña',
          confirm: 'Confirma tu contraseña',
        },
        notification: {
          success: 'Tu contraseña se ha cambiado con éxito',
          error: 'Error, connection failed',
        },
        cta: {
          submit: 'Guardar los cambios',
        },
      },
      commentCreate: {
        cta: {
          leaveComment: 'Create a review',
        },
        error: {
          noRate: 'You must rate the product',
          commentBelowMinimum: 'Minimal comment length 10 characters.',
        },
      },
      activation: {
        success: '¡Gracias por confirmar tu dirección de correo electrónico!',
      },
      steps: {
        title: '¡Es tu primer producto a evaluar!',
        success: 'Tu perfil se ha actualizado correctamente',
        error: 'Ha habido un error, pruebe de nuevo más tarde.',
        subtitle:
          'Para poder recuperar los sazcoins de tu primer producto, te vamos a pedir algunos datos que nos van a permitir ofrecerte productos adaptados a tu perfil.',
        family: 'Composición de mi hogar',
        hobbies: 'Hábitos y hobbies',
        diets: 'Mi perfil alimentario',
        next: 'Siguiente',
        goBack: 'Atrás',
        back: 'Volver',
        info: '¿Sabes que puedes probar productos infantiles así como productos para mascotas? ¡Si te interesa, háznoslo saber!',
        info2:
          'Conocer tu perfil alimentario nos permite ofrecerte productos específicos. ¡Y tu valiosa opinión ayuda a las marcas a mejorarlos!',
      },
    },
    pages: {
      unsub: {
        title: 'Indícanos por favor el motivo de tu baja',
        btn: 'Suprimir mi cuenta',
        link: 'Quiero dar de baja mi cuenta',
        reason: 'Motivo de tu baja',
        success: 'Tu cuenta se ha eliminado correctamente',
      },
      addressEdit: {
        successSend: 'Has modificado tu dirección de entrega con éxito',
        failSend: 'Ha habido un error, pruebe de nuevo más tarde.',
        btn: 'Modificar mi dirección',
      },
      confirmEmail: {
        caption: 'Procesando tu email...',
        success: {
          title: '¡Tu email ha sido confirmado!',
          text: '',
        },
        error: {
          title: 'Tu email aún no esta confirmado',
        },
      },
      sazHome: {
        welcome_blue: 'Prueba productos gratis',
        welcome_orange: 'y con descuentos',
        welcome_light: 'a cambio de tu opinión.',
        claim_1: {
          blue: 'Descubre,',
          orange: ' opina',
          light: ' y ahorra.',
        },
        claim_2: 'Elige tu cupón',
        claim_3: 'Lleva tu QR al centro de canje',
        claim_4: {
          blue: 'Prueba,',
          orange: ' opina',
          light: ' y califica.',
        },
      },
      home: {
        banner: {
          title: '¡Canjea sazcoins por productos!',
          helpTextOne: 'Elige la promoción que más te interesa y canjéala por tus créditos.',
          helpTextTwo: ' Retira de tu tienda los productos, contesta una breve encuesta y sigue eligiendo productos.',
          helpTextThree: 'Con Shopadvizor, haz que tu opinion cuente mas que nunca.',
          subtitle: 'Prueba productos gratis a cambio de tu opinión.',
          discover: 'Descubre',
          rate: 'opina',
          save: 'ahorra',
          howItWorks: '¿Cómo funciona?',
        },
      },
      promotions: {
        router: {
          postSurveySuccess: 'Gracias por completar la encuesta',
          createCouponSuccess: 'Tu cupón se ha generado correctamente. Podrás verlo en la sección de Mis Cupones',
          error: 'Lo sentimos, ha ocurrido un error, por favor, intentalo más tarde',
          creating: 'Estamos creando tu cupón, por favor espera unos segundos',
          alreadyAnswered: 'Ha ocurrido un problema al acceder a tu encuesta. Inténtalo más tarde.',
          loading: 'Cargando, un momento por favor...',
        },
        menu: {
          available: 'Promociones disponibles',
          availableMobile: 'Promociones',
          coupons: 'Mis cupones',
          couponsMobile: 'Cupones',
          couponsHistory: 'Histórico de cupones',
          orders: 'Recuperar sazcoins',
          ordersMobile: 'Recuperar',
          profile: 'Mi perfil',
          history: 'Histórico',
          credits: 'Saldo de sazcoins',
          closeSession: 'Cerrar sesión',
          totalCredits: 'sazcoins',
        },
        list: {
          title: '¿Qué productos quieres llevarte hoy?',
          activePromotion: {
            plural: '{{total}} promociones activas',
            singular: 'Una promoción activa',
          },
          showingQuantity: 'Mostrando {{showing}} de {{total}} promociones',
          showMore: 'Mostrar más',
          filter: {
            placeholder: 'Selecciona para filtrar',
            selectedAvailable: 'Disponibles en {{name}} ({{total}})',
            restAvailable: 'Resto de promociones ({{total}})',
          },
          noItems: 'No hay promociones disponibles para tu perfil en este momento. Vuelve en los próximos días.',
        },
        card: {
          redemptionPoint: {
            availableRetailers: 'Elige un punto de entrega',
            selectRetailer: 'Selecciona uno de los siguientes puntos de canje',
            availableToRedeem: 'Disponible para retirar en tu punto de canje seleccionado',
            availableToRedeemExtra: 'a las 12hs',
            redeemBefore: 'Tienes tiempo para ir a recogerlo hasta el',
            warning: 'Después de esta fecha, tu producto ya no podrá ser retirado.',
            toHomeTitle: '¿Prefieres recibirlo en casa?',
            toHome: 'Entrega a domicilio',
            homeAddress: 'Dirección de entrega',
            estimatedToPup: 'Entrega estimada: entre 48 y 72 horas hábiles.',
            estimatedToHome: 'Entrega estimada: entre 72 y 96 horas hábiles.',
            filterText: 'Filtra por ubicación: primero el distrito, luego (opcional) el corregimiento.',
            filterNoResults: 'No se encontraron puntos de entrega.',
            onlyHomeDelivery: 'Esta promoción no tiene puntos de entrega, sólo se puede enviar a domicilio.',
            filterLabels: {
              level2: 'Distrito',
              level3: 'Corregimiento',
              reset: 'Limpiar filtros',
            },
            filterPlaceholders: {
              level2: 'Selecciona un distrito',
              level3: 'Selecciona un corregimiento',
            },
          },
          ecommerce: {
            availableRetailers: 'Elige un punto de recogida',
            selectRetailer: 'Selecciona uno de los siguientes puntos de recogida',
            toOnlineTitle: '¿Prefieres comprarlo online?',
            toOnline: 'Compra online',
            website: 'URL de compra del producto',
            tooltipText: 'Elige uno de estos puntos de recogida',
            tooltipTextOnline: 'O elige esta opción si prefieres comprar online',
          },
          homeDeliveryTerms:
            'Esta promoción es de envío a domicilio. La empresa de transporte se pondrá en contacto contigo para hacerte llegar el producto. Una vez lo recibas, y pasadas unas horas, podrás evaluarlo en las sección de Recuperar sazcoins.',
          destinyData: 'Datos de envío',
          homeDelivery: {
            savedTo: 'Nombre completo',
            identifier: 'Número de identidad',
            telephone: 'Número de teléfono',
            address: 'Dirección completa',
            edit: 'Modificar mi dirección',
          },
          conditions: 'Términos y condiciones',
          validUntil: 'Promoción válida hasta',
          validUntilWhenNoEndDate: 'Finalizar existencias',
          validUntilExtraText: '(o hasta finalizar existencias)',
          redeemBefore: 'El pedido vence',
          redeemBeforeExtraText: '(si realiza la solicitud hoy)',
          availableRetailers: 'Sólo disponible en',
          requestCoupon: 'Solicitar cupón',
          loadingRequest: 'Cargando, por favor, espera',
          selectRetailer: 'Elige un punto de canje',
          selectRetailerOrHome: 'Elige una forma de entrega para continuar',
          fillProfile: 'Rellena tus datos',
          legalText:
            ' Para beneficiarse de esta promoción, debe realizar una compra minima de 30€. Puede utilizar un máximo de 4 cupones diferentes por compra realizada.',
          credits: 'sazcoins',
          activePromotions: 'Promociones Activas',
          loginMessage: 'Para beneficiarte de la promoción has de estar logueado.',
          noAccess: 'No se puede acceder a este contenido',
          couponCode: 'Código de cupón',
          evaluate: 'Opinar',
          expired: 'Expirado',
          exchange: 'Canjear',
          coupons: 'Mis Cupones',
          free: 'Gratis',
          tooltipText: 'Elige uno de estos puntos de canje',
          tooltipTextHome: 'O elige esta opción para recibirlo en casa',
        },
        labels: {
          noStock: 'Agotado',
          lastUnits: 'Últimas',
          tooltipRetailerUnavailable:
            'Esta promoción está agotada en este punto de canje. La podrás retirar en otros en los que haya stock.',
        },
        concepts: {
          createOrder: 'Solicitud: {{name}}',
          cancelOrder: 'Cancelación: {{name}}',
        },
        errors: {
          default: 'Ha ocurrido un error al verificar la promoción actual. No se pudo solicitar.',
          noStock: 'Esta promoción se ha quedado sin unidades disponibles.',
          limitRequested:
            'Has llegado al máximo de pedidos (4) que puedes tener disponibles. Para poder solicitar otros productos deberás evaluar o anular los cupones que tienes solicitados. Accede a Mis cupones o a Recuperar créditos para realizar esta acción.',
          alreadyRequested: 'Este pedido ya ha sido realizado. Podrás encontrar tu cupón en la sección Mis cupones.',
          promotionInactive: 'La promoción seleccionada ya no está activa.',
          retailerNotFound:
            'El punto de canje seleccionado ya no está disponible. Por favor prueba seleccionando otro distinto.',
          retailerNoStock:
            'Este punto de canje ya no tiene stock disponible. Por favor prueba seleccionando otro distinto.',
          noCredits:
            'Esta promoción no se puede solicitar, no tienes suficientes sazcoins para ello. Para recuperar tus sazcoins utilizados podrás anular cupones que no vayas a retirar desde Mis Cupones o evaluar alguno de los que ya tengas desde la pantalla de Recuperar sazcoins.',
        },
        tooltip: {
          today: 'A retirar hoy',
          tomorrow: 'Último día para retirar el producto es mañana',
          days: 'A retirar antes de {{n}} días',
        },
      },
      coupons: {
        title: 'Mis cupones',
        emptyMainText: 'En esta pantalla encontrarás tus cupones solicitados.',
        subText:
          'Ahora mismo no tienes cupones esperando a ser redimidos. No dudes en elegir tus productos favoritos en "Promociones disponibles".',
        helpTextOne:
          'Para obtener el cupón que le permite retirar el producto seleccionado, simplemente haga clic sobre la tarjeta del producto.',
        helpTextTwo:
          'Si no va a utilizar el cupón, no dude en cancelarlo indicando claramente el motivo, pudiendo recuperar sus sazcoins.',
        helpTextThree:
          'Si ya ha recogido el producto en tienda y quiere evaluarlo para recuperar sus sazcoins, entre en el detalle del cupón y haga clic en "Ya lo he redimido".',
        card: {
          title: 'Detalle de cupón',
          productCode: 'Código de producto',
          couponCode: 'Código de cupón',
          validUntil: 'Tienes tiempo para ir a recogerlo hasta el',
          availableRetailers: 'Disponible en tiendas',
          retailerToRedeem: 'A retirar en',
          alreadyRedeemed: 'Ya lo he redimido',
          redeemFrom:
            'Ya puedes retirar el producto. Presenta este código QR en el punto Shopadvizor para recibir el producto.',
          redeemFromExtra: 'a las 12hs',
          print: 'Imprimir',
          cancelCoupon: 'Anular cupón',
          savedTo: 'Oferta reservada a',
          phone: 'Número de teléfono móvil asociado',
          email: 'Email asociado',
          identifier: 'Número de identidad',
          telephone: 'Número de teléfono',
          address: 'Envío programado a la dirección',
          legalText:
            'Este cupón (junto con todos los anexos) está estrictamente reservado para el uso de la persona o entidad a quien va dirigida. Puede contener información privilegiada y confidencial. Si no es usted el destinatario indicado, cualquier divulgación, distribución o copia de este mensaje está estrictamente prohibida.',
        },
        redeem: {
          header: 'Redimir cupón',
          title: '¿Ya has retirado el producto?',
          confirmText: 'Para confirmar que has canjeado el cupón, por favor, complete la siguiente información:',
          dateSelector: '¿Cuando fuiste a la tienda?',
          validate: 'Validar',
          waitMessage: 'Validando. Por favor, espera...',
          retailerOptions: '¿En que tienda retiraste el producto?',
          errors: {
            NO_DATE: 'Por favor, selecciona una fecha',
            DATE_IS_THE_FUTURE: 'La fecha no puede ser en el futuro',
            NO_RETAILER: 'Por favor, selecciona un retailer',
            NOT_VALID: 'Ha ocurrido un error: La fecha de retirada no es válida.',
          },
          successRedeemToastMessage: 'Tu promoción ha sido evaluada y tus sazcoins han sido devueltos correctamente.',
          errorRedeemToastMessage: 'Lo sentimos, ha habido un error al evaluar tu promoción.',
        },
        cancel: {
          header: 'Anular cupón',
          title: '¿Deseas anular el cupón?',
          subtitle: 'Para anular el cupón, por favor, dinos por qué:',
          notFoundOption: 'No encontré el producto en la tienda',
          forgotOption: 'Fui a la tienda pero olvidé llevarme el producto',
          dontWantOption: 'Decidí no canjear el cupón',
          couponNotWorking: 'El cupón no funcionó y no me dieron el descuento',
          otherReasons: 'Otras razones',
          waitMessage: 'Cancelando. Por favor, espera...',
          expired: 'El cupón expiró y no lo he usado',
          cancelReasonLabel: 'Razón (mínimo 10 carácteres)',
          cancelButton: 'Anular',
          successCancelToastMessage: 'Tu cupón ha sido cancelado y tus sazcoins han sido devueltos correctamente.',
          errorCancelToastMessage: 'Lo sentimos, ha habido un error al cancelar tu cupón.',
          withDrawal: {
            noStockOption: 'No había stock en el punto de canje',
            notWorkingOption: 'No funcionaba el cupón',
            dontWantOption: 'Decidí no canjear el producto',
            noTimeOption: 'No me va a dar tiempo a retirar el producto',
            otherReasons: 'Otras razones',
          },
        },
        tooltip: {
          today: '¡Este cupón vence hoy!',
          tomorrow: '¡Este cupón vence mañana!',
          days: 'Quedan {{n}} días para que venza este cupón',
        },
        bulkPdfButton: 'Descargar mis cupones en PDF',
        pdf: {
          title: 'Preview de cupones en PDF',
          close: 'Cerrar',
          download: 'Descargar',
        },
      },
      couponsHistory: {
        title: 'Histórico de cupones',
        requestDate: 'Fecha solicitado',
        redemptionDate: 'Fecha de redención',
        couponCode: 'Código cupón',
        retailer: 'Tienda',
        credits: 'sazcoins',
        loadingMore: 'Cargando tu historial, espera un momento por favor',
        notCouponsMessage: 'Todavia no tienes ningún cupón canjeado',
      },
      creditsHistory: {
        title: 'Saldo de créditos',
        loadingMore: 'Cargando tu historial, espera un momento por favor',
        noData: 'Todavía no tienes movimientos en tus sazcoins',
        header: {
          date: 'Fecha',
          concept: 'Concepto',
          credits: 'sazcoins',
        },
        pagination: {
          showingPageOf: 'Mostrando página {{actual}} de {{total}}',
          next: 'Siguiente >',
          prev: '< Anterior',
        },
      },
      credits: {
        title: 'Recuperar sazcoins',
        mainText: 'En esta pantalla encontrarás tus cupones solicitados',
        helpTextOne: 'Aquí aparecen las promociones que ya has retirado y puedes evaluar.',
        helpTextTwo:
          'Tómate unos minutos para calificar el producto que has probado y recupera los sazcoins utilizados al pedirlo para poder acceder a otras promociones.',
        helpTextThree: 'Gracias por responder de la manera más objetiva y sincera posible, te estamos agradecidos.',
        noItems:
          'Pide promociones utilizando tus sazcoins disponibles y retíralas antes de su fecha de vencimiento. Cuando ya hayas probado el producto, podrás evaluarlo para recuperar tus sazcoins.',
        actions: {
          requestedText: '¿Has retirado ya el producto en la tienda?',
          redeemedText: '¿Has probado el producto?',
          alreadyRedeemed: 'Ya lo he redimido',
          cancelCoupon: 'Anular cupón',
          evaluate: 'Evaluar',
        },
      },
      po30: {
        rating: {
          label: 'Calificación general',
          subtitle: '¿Qué calificación del 1 al 5 le darías a este producto?',
          belowText: 'Tu opinión sincera es importante y ayudará a otros consumidores',
          error: 'Califica seleccionando estrellas',
        },
        nps: {
          label: '¿Cuánto recomendaría este producto?',
          error: 'Debes elegir una calificación entre 1 y 10',
        },
        title: {
          label: 'Añade un título a tu reseña',
          placeholder: '¿Cuál es el elemento más importante?',
          error: 'Escribe un título de al menos 5 caracteres',
        },
        review: {
          label: 'Escribe tu reseña',
          title: {
            placeholder_1_2: '¿Por qué tu experiencia con este producto fue mala?',
            placeholder_3: '¿Qué aspectos mejorarías del producto?',
            placeholder_4_5: '¿Qué destacarías de este producto?',
            placeholder: 'Resume tu experiencia con el producto',
          },
          placeholder_1_2:
            '¿Qué problemas encontraste? ¿Qué debería mejorar? Tu opinión ayudará a mejorar el producto y ayudará a otros consumidores a decidir si es adecuado para ellos.',
          placeholder_3:
            'Cuéntanos tu experiencia con el producto. ¿Qué te gustó y qué mejorarías del producto para que te resulte más atractivo?',
          placeholder_4_5:
            'Describe tu experiencia con el producto. ¿Qué es lo que más te gustó? ¿Por qué lo recomendarías?',
          placeholder:
            'Comparte tu experiencia después de probar el producto. ¿Qué te gustó o no? ¿Cumple lo que promete? ¿Lo recomendarías?Cuéntanos los detalles, su uso y sus características.',
          error: 'Escribe una reseña de al menos 25 caracteres.',
          submitError:
            'Se ha producido un error técnico, inténtelo de nuevo en unos momentos. Si el problema persiste, inicie sesión nuevamente',
        },
        submit: 'Siguiente',
      },
      promotion: {
        title: 'Detalle de promoción',
        back: 'volver al listado',
        ean: 'EAN de producto',
      },
      productDetail: {
        caption: {
          ctaToolTipStarsBefore: 'Hey, hey,',
          ctaToolTipStarsAfter: 'you can touch the stars!',
          ingredients: 'Ingredients',
          allergens: 'Allergens',
          description: 'Description',
          nutrients: 'Nutrients',
          moreInfo: 'More information',
          ratingDetails: 'Rating details',
          productRating: 'Current product rating',
          userReviews: 'User reviews',
          nutriscore: 'About nutriscore',
          range: 'Nutrients range',
          totalReviews: '(Total reviews)',
        },
        texts: {
          ratingDetails:
            'Basically, the nutritional value for the our grade is determined by subtracting the total ' +
            'positive points from the total negative points. And the lower the score, the better the letter grade.',
          nutriscore:
            'Voici comment est attribué le Nutri-Score, un algorithme attribue des points à chaque élément repris dans le ' +
            'tableau des valeurs nutritionnelles (par 100 g ou 100 ml), tant pour les substances alimentaires bénéfiques ' +
            'affichant un score négatif (protéines, fibres, quantité de fruits, de légumes, de fruits à coque, d&apos;huile ' +
            'de colza, d&apos;huile de noix et d&apos;huile d&apos;olive) que pour les substances alimentaires moins ' +
            'bénéfiques affichant un score positif (haute valeur énergétique [kJ], sucres, acides gras saturés, sel).' +
            'Ensuite, les points positifs (moins bénéfiques, donc) sont déduits des points négatifs (bénéfiques) et le' +
            'résultat est converti dans le tableau du Nutri-Score. ',
        },
      },
      successSignUp: {
        caption: {
          title: 'Activa tu cuenta para continuar.',
        },
        texts: {
          success:
            'Te hemos enviado un email para activar tu cuenta. Revisa tu bandeja de entrada y si no lo encuentras, también SPAM o Promociones.',
          back: 'Ya activé mi cuenta y quiero descubrir productos',
        },
      },
      survey: {
        simulator: {
          title: 'Simulación de encuesta',
        },
        extra: {
          back: 'Volver atrás',
          item: 'Tu producto',
          title: 'Encuesta',
          finish: 'Muchas gracias. Ya has respondido a esta encuesta',
          button: 'Continuar',
          errorSaving: 'Ha ocurrido un error al grabar tu respuesta',
          errorInit: 'Ha ocurrido un error al inicializar la encuesta. Inténtalo de nuevo en unos instantes',
          errors: {
            inactive: 'Esta encuesta ya no está disponible.',
          },
          reward: 'Se le han asignado {{points}} sazcoins que tendrán validez hasta el {{date}}',
        },
      },
    },
    banners: {
      feedback: {
        title: '¡Estamos en fase de prueba!',
        open: 'Ayúdanos ',
        text: 'Para ayudarnos a mejorar, envíanos tus comentarios a<br /><link1>contacto@shopadvizor.com.pa</link1>!',
      },
    },
  },
};

export default SpanishMexicoTranslation;
